

































import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/atoms/Grid/Container.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import { toNumber } from '@/utils/moneyTreatments';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';

@Component({
  components: {
    FilledButton,
    Container,
    TextField,
    Typography,
    SideModalHeader
  }
})
export default class CoinStoreReturnWallet extends Vue {
  @Prop() readonly data!: any;
  coins = '';

  loading = false;
  adminService = new AdminService();

  isValid() {
    if (!this.coins || toNumber(this.coins) <= 0) {
      this.$notification('Please fill the fields', 'error');
      return false;
    }

    if (toNumber(this.coins) > toNumber(this.data.coinsAvailable)) {
      this.$notification(
        'This wallet has insufficient funds at the moment',
        'error'
      );
      return false;
    }

    return true;
  }

  async sendCoins() {
    if (!this.isValid()) {
      return;
    }

    const onConfirm = async () => {
      try {
        const { status } = await this.adminService.sendTwismCoinsToTwismWallet(
          this.data.id,
          toNumber(this.coins)
        );
        if (status === 201) {
          this.$notification('Success');
          eventBus.$emit('closeModal');
          eventBus.$emit('reloadCoinStore');
          eventBus.$emit('reloadCoinStoreHistory');
        }
      } catch (e) {
        treatError(e);
      } finally {
        this.loading = false;
        this.coins = '';
      }
    };

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'coinStoreConfirmModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: {
          coins: toNumber(this.coins)
        },
        title: `Are you sure?`,
        subtitle: `${toNumber(
          this.coins
        )} Coins will be sent back to Twism Wallet:`,
        onConfirm
      }
    );
  }

  closeModal() {
    if (this.data.close) {
      this.data.close();
    }
  }
}
